import {fuchiFloors} from './fuchiFloors';
import {getFloorEcology} from './floorEcology';

export const specimenTiers = {
  1: {name: '土', color: '#8B7D6B', effect: '無光'},
  2: {name: '錆', color: '#8BA0A8', effect: '微藍光'},
  3: {name: '月白 R', color: '#D1D5D6', effect: '銀白高光'},
  4: {name: '金茶 SR', color: '#D4B26A', effect: '金脈流動'},
  5: {name: '朱金 SSR', color: '#C73A2A', effect: '朱金門扉'},
  6: {name: '墨虹 EX', color: '#0A0A0A', effect: '虹彩漣漪'}
};

const landmarkSpecimens = {
  3: [{name: '花瓣入水拓', tier: 4, note: '櫻花掉進桶的瞬間'}],
  7: [{name: '祖鮭心跳記錄', tier: 4, note: '呼應九十一層鮭神'}],
  10: [{name: '迴游羅盤', tier: 5, note: '記錄淺層魚群遷移路線'}],
  20: [{name: '鰤王之顎', tier: 5, note: '鰤王試練留下的核心部位'}],
  25: [{name: '銀龍捲核心', tier: 5, note: '萬尾鯵群形成的渦心'}],
  29: [{name: '境界之膜', tier: 6, note: '晨光與深淵的分界'}],
  30: [{name: '赤鳥居御守', tier: 5, note: '問診之間的安全層護符'}],
  40: [{name: '鯨骨橋鑰匙', tier: 5, note: '從鯨骨深處取出的古老骨鍵'}],
  45: [{name: '玉澄共鳴', tier: 5, note: '守火血脈留下的溫暖殘響'}],
  50: [{name: '中間之眼', tier: 6, note: '凝視上下兩界的塔心之眼'}],
  55: [{name: '王鮪紅眼', tier: 5, note: '深海王鮪用以辨認獵物的紅眼'}],
  59: [{name: '絕對暗', tier: 6, note: '無光之底凝結的黑暗本身'}],
  60: [{name: '黑鳥居御守', tier: 5, note: '守火之間的安全層護符'}],
  73: [{name: '千刀墓碑', tier: 5, note: '無名板前舊刀匯聚的墓碑'}],
  78: [{name: '醬油瀑布源頭', tier: 5, note: '仍在流動的百年古醬油'}],
  81: [{name: '無主的壽司魂', tier: 6, note: '尋找原來客人的完成品'}],
  85: [{name: '初代問答', tier: 5, note: '忘卻板長留下的唯一提問'}],
  88: [{name: '空', tier: 6, note: '空桶內放大的無形回聲'}],
  89: [{name: '最古刀痕', tier: 6, note: '神明落下的世界第一道刀痕'}],
  90: [{name: '金色注連繩', tier: 5, note: '無心之間的最終守護'}],
  91: [
    {name: '始祖鮭神燃鱗', tier: 6, note: '紅洄脫落後仍持續燃燒的金鱗'},
    {name: '神代逆流之水', tier: 5, note: '只向源頭流動的神域水滴'}
  ],
  92: [
    {name: '天黃世界膜', tier: 6, note: '始祖玉子神包覆世界的柔軟薄膜'},
    {name: '守火神溫', tier: 5, note: '不會冷卻的柔和餘溫'}
  ],
  93: [
    {name: '櫻躍時間殼', tier: 6, note: '封存蝦神躍起瞬間的透明甲殼'},
    {name: '慢時觸鬚', tier: 5, note: '周圍時間仍比外界緩慢'}
  ],
  94: [
    {name: '無星宇宙墨', tier: 6, note: '能抹去光與邊界的一滴神墨'},
    {name: '墨眷透明骨', tier: 5, note: '只有離開黑暗後才看得見'}
  ],
  95: [
    {name: '金爆神棘', tier: 6, note: '封存始祖海膽神的鮮味脈衝'},
    {name: '超新星海膽核', tier: 5, note: '仍規律釋放微弱金光'}
  ],
  96: [
    {name: '銀河神鯖圖', tier: 6, note: '每片銀鱗都對應一顆星'},
    {name: '永洄軌道鱗', tier: 5, note: '離水後仍沿環形路徑移動'}
  ],
  97: [
    {name: '天衡神眼淚晶', tier: 6, note: '映出持有者未曾承認的選擇'},
    {name: '御前赤身血珠', tier: 5, note: '鮪神近衛留下的凝結血珠'}
  ],
  98: [
    {name: '百層鯨神歌骨', tier: 6, note: '靠近耳邊可聽見整座塔的共鳴'},
    {name: '神歌水紋', tier: 5, note: '離開水面後仍未消散的波紋'}
  ],
  99: [
    {name: '眾旬神審判票', tier: 6, note: '記錄眾神對來訪者的共同判決'},
    {name: '百旬神使之羽鱗', tier: 5, note: '同時帶有百層不同氣息'}
  ],
  100: [
    {name: '一期一會原生旬味', tier: 6, note: '只在心跳同步時出現一次'},
    {name: '源心味噌脈', tier: 6, note: '來自月球味噌心臟的核心脈絡'},
    {name: '百年未言之心', tier: 6, note: '整座塔最深處保存的無聲回答'}
  ]
};

const habitatDrops = {
  Shallow: [
    {name: '晨光魚鱗', note: '淺層魚群迎光轉向時脫落'},
    {name: '洄游水珠', note: '仍保留魚群移動方向'},
    {name: '桶緣潮鹽', note: '淺瀨水氣凝結的薄鹽'}
  ],
  Deep: [
    {name: '深壓魚骨', note: '受水壓塑形的緻密骨片'},
    {name: '磷光黏液', note: '深海生物留下的微藍軌跡'},
    {name: '沉水黑砂', note: '從不被上升水流帶走'}
  ],
  Ancient: [
    {name: '記憶魚鱗', note: '表面映出不完整的古代刀法'},
    {name: '古木沉屑', note: '百年桶壁剝落的深色木片'},
    {name: '失傳味塵', note: '無法以現代語言描述的味覺殘留'}
  ],
  Mythical: [
    {name: '神域光塵', note: '受到血脈共鳴後才會凝結'},
    {name: '始祖氣息', note: '帶有對應旬神的微弱脈動'},
    {name: '無重力水晶', note: '離開神域後仍懸浮不落'}
  ]
};

const creatureDrops = {
  fish: {name: '旬魚側線鱗', note: '能感應此層水流的細小銀鱗'},
  salmon: {name: '逆流紅鱗', note: '離水後仍朝源頭微微顫動'},
  tuna: {name: '高速魚腱', note: '保存大型洄游魚的爆發力量'},
  mackerel: {name: '青銀油膜', note: '映出一瞬即逝的藍綠光澤'},
  school: {name: '群游共鳴鱗', note: '靠近同類時會同步閃光'},
  'flying-fish': {name: '水切胸鰭', note: '薄如刀刃，可切開急流'},
  eel: {name: '桶隙黏膜', note: '能在乾燥木縫中保持濕潤'},
  squid: {name: '活性墨囊', note: '受驚時仍會釋放一小團墨'},
  octopus: {name: '擬態吸盤', note: '會依放置表面改變色澤'},
  crab: {name: '鏽甲碎片', note: '吸收了沉沒金屬的色澤'},
  urchin: {name: '深棘核心', note: '微弱脈動與周圍棘群一致'},
  jellyfish: {name: '磷光傘膜', note: '隨水壓變化發出柔藍光'},
  shell: {name: '潮音珠', note: '貼近耳邊可聽見所在樓層'},
  angler: {name: '幽燈囊', note: '在完全黑暗中才會亮起'},
  whale: {name: '低鳴骨片', note: '觸碰時傳出低頻共鳴'},
  spirit: {name: '記憶殘響', note: '保存靈體現身前最後的念頭'},
  cat: {name: '偷鮮鬍鬚', note: '總會指向此層最肥美的獵物'}
};

function defaultTier(floor, offset) {
  if (floor >= 91) return offset === 0 ? 5 : 6;
  if (floor >= 61) return offset === 0 ? 3 : 4;
  if (floor >= 31) return offset === 0 ? 2 : 3;
  if (floor % 10 === 0) return 4;
  if (floor % 5 === 0) return offset === 0 ? 3 : 4;
  return Math.min(3, 1 + ((floor + offset * 3) % 3));
}

function createEcologyDrops(floor) {
  const ecology = getFloorEcology(floor);
  const drops = [];
  const habitat = habitatDrops[floor.realm];
  const habitatDrop = habitat[floor.floor % habitat.length];

  drops.push({
    name: `${floor.ingredient}標本`,
    tier: defaultTier(floor.floor, 0),
    note: '此層主要旬味留下的完整樣本'
  });

  if (!ecology.safe && ecology.creatures.length) {
    const creature = ecology.creatures[floor.floor % ecology.creatures.length];
    const drop = creatureDrops[creature.type] || creatureDrops.fish;

    drops.push({
      name: floor.floor >= 91
        ? `${creature.name}之證`
        : drop.name,
      tier: defaultTier(floor.floor, 1),
      note: floor.floor >= 91
        ? `${creature.name}顯現時留下的神性殘片`
        : `${drop.note}；來源：${creature.name}`
    });
  } else {
    drops.push({
      name: `${floor.name_zh}安息水`,
      tier: defaultTier(floor.floor, 1),
      note: '安全層平靜水域凝結的透明樣本'
    });
  }

  drops.push({
    name: habitatDrop.name,
    tier: defaultTier(floor.floor, 2),
    note: habitatDrop.note
  });

  if (floor.floor % 4 === 0 && floor.floor < 91) {
    drops.pop();
  }

  return [...drops, ...(landmarkSpecimens[floor.floor] || [])];
}

export const specimenFloors = fuchiFloors.map((floor) => ({
  floor: floor.floor,
  name: floor.name_zh,
  zone: floor.realm,
  items: createEcologyDrops(floor)
}));

export function getSpecimenFloor(floor) {
  return specimenFloors[floor - 1];
}